module.exports = __webpack_public_path__ + "static/media/016ty@3x.b0518336.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/016ty@3x.png
// module id = 1666
// module chunks = 0 1